import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteMaterialRequestActions'
import * as api from '../../api/job/jobSiteMaterialRequests'

function* jobSiteMaterialRequestsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteMaterialRequests, action.jobId)
    yield put({ type: constants.MATERIAL_REQUEST_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.MATERIAL_REQUEST_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteMaterialRequests() {
  yield takeLatest(constants.MATERIAL_REQUEST_REFRESH.ACTION, jobSiteMaterialRequestsRefresh)
}

function* sagaCreateJobSiteMaterialRequest(action) {
  try {
    const payload = {
      request_items: action.requestItems,
      job_id: action.jobId,
      data: {
        job_id: action.jobId,
        status: action.content.status,
        description: action.content.description,
        requested_by: action.content.requested_by,
        material_request_template_id: action.content.material_request_template_id,
        created_by_id: action.userId,
        updated_by_id: action.userId
      }
    }
    yield call(api.createJobSiteMaterialRequest, payload)
    yield put({ type: constants.CREATE_MATERIAL_REQUEST.SUCCESS, payload })
    yield call(jobSiteMaterialRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_MATERIAL_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteMaterialRequest() {
  yield takeLatest(constants.CREATE_MATERIAL_REQUEST.ACTION, sagaCreateJobSiteMaterialRequest)
}

function* sagaUpdateJobSiteMaterialRequest(action) {
  try {
    const payload = {
      request_items: action.requestItems,
      material_request_id: action.materialRequestId,
      job_id: action.jobId,
      data: {
        description: action.content.description,
        completed: action.content.completed,
        status: action.content.status,
        material_request_template_id: action.content.material_request_template_id,
        completed_date: action.content.completed_date,
        requested_by: action.content.requested_by,
        updated_by_id: action.userId,
        created_by_id: action.userId
      }
    }
    yield call(api.updateMaterialRequest, payload)
    yield put({ type: constants.UPDATE_MATERIAL_REQUEST.SUCCESS, payload })
    yield call(jobSiteMaterialRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_MATERIAL_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteMaterialRequest() {
  yield takeLatest(constants.UPDATE_MATERIAL_REQUEST.ACTION, sagaUpdateJobSiteMaterialRequest)
}

function* sagaDeleteJobSiteMaterialRequest(action) {
  try {
    const payload = {
      material_request_id: action.materialRequestId
    }
    yield call(api.deleteMaterialRequest, payload)
    yield put({ type: constants.DELETE_MATERIAL_REQUEST.SUCCESS, payload })
    yield call(jobSiteMaterialRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_MATERIAL_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteMaterialRequest() {
  yield takeLatest(constants.DELETE_MATERIAL_REQUEST.ACTION, sagaDeleteJobSiteMaterialRequest)
}

function* getMaterialItems(action) {
  try {
    const payload = yield call(api.getMaterialItems, action.materialRequestId)
    yield put({ type: constants.GET_MATERIAL_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_MATERIAL_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetMaterialItems() {
  yield takeLatest(constants.GET_MATERIAL_ITEMS.ACTION, getMaterialItems)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      materialRequestId: action.materialRequestId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { materialRequestId: action.materialRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_MATERIAL_REQUESTS_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.materialRequestId)
    yield put({ type: constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_MATERIAL_REQUESTS_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { materialRequestId: action.materialRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_MATERIAL_REQUESTS_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      materialRequestId: action.materialRequestId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { materialRequestId: action.materialRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_MATERIAL_REQUESTS_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteMaterialRequests),

    fork(watchCreateJobSiteMaterialRequest),
    fork(watchUpdateJobSiteMaterialRequest),
    fork(watchDeleteJobSiteMaterialRequest),

    fork(watchGetMaterialItems),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteMaterialRequestSaga.js